import Bugatti from "./car-detail/Bugatti";
import Ferrari from "./car-detail/Ferrari";
import Lamborghini from "./car-detail/Lamborghini";
import MercedesBenz from "./car-detail/MercedesBenz";
import Pagani from "./car-detail/Pagani";
import AstonMartin from "./car-detail/AstonMartin";
import Arrinera from "./car-detail/Arrinera";
import Audi from "./car-detail/Audi";
export const CarsInBrand = {
    Bugatti: Bugatti,
    Ferrari: Ferrari,
    Lamborghini: Lamborghini,
    MercedesBenz: MercedesBenz,
    Pagani: Pagani,
    AstonMartin: AstonMartin,
    Arrinera: Arrinera,
    Audi: Audi,
};
